import { createFileRoute } from '@tanstack/react-router'
import { ExamEditorPage } from '@/features/exams/editor'

export const Route = createFileRoute('/exams_/$examId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { examId } = Route.useParams()
  return <ExamEditorPage examId={examId} />
}
